import { success, failure, request } from 'app/actions';
import * as actions from './composingCorrectionActions';
import * as helpers from '../simulatedHelpers';

const initialState = {
  evaluation: {
    evaluation: {
      catalogings: [],
      idString: '',
      idStep: 0,
      levelSegment: [],
    },
  },
  schoolOptions: [],
  contract: {},
  completed: false,
  isLoading: false,
  correctComposingSheetState: {
    error: undefined,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case request(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: initialState.evaluation,
        completed: initialState.completed,
        forbidden: initialState.forbidden,
        students: initialState.students,
        totalWarning: initialState.totalWarning,
        isLoading: false,
      };
    case success(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: helpers.getEvaluationInformation(action.payload.content),
        schoolOptions: helpers.getSchoolCSOptions(action.payload.content),
        contract: action.payload.content.contract,
        completed: action.payload.content.evaluation.dates.some(
          (d) => d.component === 'diagramming' && d.complete,
        ),
        forbidden: false,
      };
    case failure(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        forbidden: true,
        isLoading: false,
      };
    case success(actions.GET_STUDENT_ANSWER_LIST):
      return {
        ...state,
        students: action.payload.content.students
          ? action.payload.content.students
          : initialState.students,
        totalWarning: action.payload.content.totalWarning || initialState.totalWarning,
      };
    case request(actions.UPLOAD_EVALUATION_ESSAY_CARD):
      return {
        ...state,
        correctComposingSheetState: {
          error: initialState.correctComposingSheetState.error,
        },
      };
    case success(actions.UPLOAD_EVALUATION_ESSAY_CARD):
      return {
        ...state,
        correctComposingSheetState: {
          error: initialState.correctComposingSheetState.error,
        },
      };
    case failure(actions.UPLOAD_EVALUATION_ESSAY_CARD):
      return {
        ...state,
        correctComposingSheetState: {
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};

export default reducer;
